<script>
export default {
  name: 'ul.form.btn.cancel.component',
  props: {
    module: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    click() {
      this.module.cancel();
      this.$emit('click');
    },
  },
};
</script>
<template>
  <UlBtnDefault
    class="ul-form-btn-cancel"
    :disabled="disabled"
    @click="click"
  >
    <slot></slot>
  </UlBtnDefault>
</template>
